__turbopack_context__.v({
  "artworkBody": "PqVmMG_artworkBody",
  "artworkGrade": "PqVmMG_artworkGrade",
  "artworkImage": "PqVmMG_artworkImage",
  "artworkImageButton": "PqVmMG_artworkImageButton",
  "artworkImageGrid": "PqVmMG_artworkImageGrid",
  "artworkImageWrapper": "PqVmMG_artworkImageWrapper",
  "artworkStudent": "PqVmMG_artworkStudent",
  "artworkTitle": "PqVmMG_artworkTitle",
  "noImageSvg": "PqVmMG_noImageSvg",
});
